































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator';
import GExamCreateFormFormat from '../GExamCreateFormFormat.vue';
import { GEnum } from '@/constants/enum.defination';
import { masterModule } from '@/store/modules/entities/master.module';
import { QuestionType } from '@/models/evalSetting/question-type';
import { AdditionalPlan } from '@/models/additional-plan/additional-plan';
import { Competency, CompetencySettingType, SettingType } from '@/models/competency/competency';
import GExamCreateSelection from './GExamCreateQuestionSettingCompetencySelection.vue';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import GExamCreateDetailSetting from '@/views/GExamCreate/QuestionSetting/GExamCreateQuestionSettingDetail.vue';
import { examCreateModule } from '@/store/modules/frames/exam-create.module';
import { required } from 'vuelidate/lib/validators';
import { Trend } from '@/models/trend/trend';
import { GPageBase } from '@/mixins';
import GVTag from '@/components/GVTag.vue';
import { customCompetencyModule } from '@/store/modules/frames/custom-competency.module';
import { CustomCompetency } from '@/models/competency/competency';
import moment from 'moment';

@Component({
  name: 'GExamCreateQuestionSetting',
  components: { GVTag, GExamCreateDetailSetting, GExamCreateSelection, GExamCreateFormFormat },
  computed: {},
  methods: {},
  validations: {
    evalSettingDetail: {
      trendIDs: { required },
    },
  },
})
export default class GExamCreateQuestionSetting extends Mixins(GPageBase) {
  competencySettingType: GEnum.CompetencySettingType = GEnum.CompetencySettingType.Full;
  freeWordSkillRequiredRadio: GEnum.RadioLabel = GEnum.RadioLabel.False;
  iatRequired: boolean = true;
  selfEvalRequired: boolean = true;
  giftRequired: boolean = true;
  isProgressNotification: boolean = true;
  requiredRespondents: number = 3;
  selectCompetencySet: number = 0;

  async mounted() {
    //設問設定画面到達フラグをセット
    examCreateModule.setVisitQuestionSettingView(true);
    // 内田洋行タイプの場合 コンピテンシーは固定でセットする
    if (this.isDispCtrlTypeUchida) {
      this.evalSettingDetail.competencySettingType = GEnum.CompetencySettingType.Uchida;
      this.handleChangeCompetencySettingType(GEnum.CompetencySettingType.Uchida);
    }
  }

  get competencySettingTypeFull(): GEnum.CompetencySettingType {
    return GEnum.CompetencySettingType.Full;
  }
  get competencySettingTypeMini(): GEnum.CompetencySettingType {
    return GEnum.CompetencySettingType.Mini;
  }
  get competencySettingTypeCustomize(): GEnum.CompetencySettingType {
    return GEnum.CompetencySettingType.Customize;
  }
  get competencySettingTypeRecommend(): GEnum.CompetencySettingType {
    return GEnum.CompetencySettingType.Recommend;
  }
  get competencySettingTypeUchida(): GEnum.CompetencySettingType {
    return GEnum.CompetencySettingType.Uchida;
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get isEvalItemAllUnchecked(): boolean {
    return true;
  }

  get isPastStartTime(): boolean {
    return moment(this.evalSettingDetail.startTime) <= moment(new Date());
  }

  /**
   * 設問タイプ
   * ライトプラン（内田洋行セット）の場合、名称（title）を上書きしている
   */
  get questionTypes(): QuestionType[] {
    if (this.isDispCtrlTypeUchida) {
      return masterModule.questionTypes.map((qt: QuestionType) => {
        if (qt.questionTypeID == GEnum.QuestionTypes.OneTypes) qt.title = '高等学校版';
        if ([GEnum.QuestionTypes.Primary, GEnum.QuestionTypes.PrimaryL, GEnum.QuestionTypes.GeneralPrimary].includes(qt.questionTypeID)) qt.title = '小学校版';
        if (qt.questionTypeID == GEnum.QuestionTypes.TwoTypes) qt.title = '中学校版';
        return qt;
      });
    } else {
      return masterModule.questionTypes;
    }
  }

  // 設問タイプが2件以上存在し、選択可能か判定
  // 設問タイプが「2件未満」（1件）の時は、画面から「設問タイプ」の選択領域を非表示にする
  // （設問タイプはデフォルトで設定されている）
  get isSelectableQuestionType(): boolean {
    return this.questionTypes.length > 1;
  }

  get miniTooltip(): string {
    const competency: CompetencySettingType = masterModule.competencySettingType;
    return this.convertToCompetencyTooltip(competency.miniCompetencies);
  }

  get recommendTooltip(): string {
    const competency: CompetencySettingType = masterModule.competencySettingType;
    return this.convertToCompetencyTooltip(competency.recommendCompetencies);
  }

  get evalSettingModeEditAndUnderExamination(): boolean {
    return examCreateModule.evalSettingModeEdit && this.evalSettingDetail.isUnderExamination;
  }

  get isDisplayTrend(): boolean {
    // 追加サービスプランに傾向チェックが含まれている場合、表示する
    return this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademic);
  }

  get isTrendIDsValid(): boolean {
    // 傾向チェックが有効な場合、傾向チェック項目が1つ以上選択されていることをチェック
    if (this.evalSettingDetail.trendRequiredRadio === GEnum.RadioLabel.True) {
      this.$v.evalSettingDetail.trendIDs.$touch();
      return this.$v.evalSettingDetail.trendIDs.$dirty && !this.$v.evalSettingDetail.trendIDs.$invalid;
    } else {
      return true;
    }
  }

  get isDetailSettingValid(): boolean {
    const { detailSetting }: any = this.$refs;
    return this.evalSettingDetail.competencySettingType !== GEnum.CompetencySettingType.Customize || detailSetting.isValid();
  }

  get isValid(): boolean {
    return this.isTrendIDsValid && this.isDetailSettingValid;
  }

  /**
   * 内田洋行タイプ
   */
  get isDispCtrlTypeUchida(): boolean {
    return this.$store.state.account.dispCtrlType === GEnum.DispCtrlType.Uchida;
  }

  /**
   * カスタマイズ（さらに詳しい設定）または内田洋行タイプ
   */
  get isCompetencySettingTypeCustomOrUchida(): boolean {
    // 現在選択されている【設問数選択】が「さらに詳しい設定」
    const isSelectedCustom = this.evalSettingDetail.competencySettingType === this.competencySettingTypeCustomize;
    // 現在選択されている【設問数選択】が「内田洋行設定」の場合
    const isSelectedUchida = this.evalSettingDetail.competencySettingType === this.competencySettingTypeUchida;
    // 「さらに詳しい設定」または「内田洋行設定」である
    if (isSelectedCustom || isSelectedUchida) {
      return true;
    }
    // 上記以外（）
    return false;
  }

  /**
   * カスタマイズ（さらに詳しい設定）
   */
  get isCompetencySettingTypeCustom(): boolean {
    // 現在選択されている【設問数選択】が「さらに詳しい設定」
    return this.evalSettingDetail.competencySettingType === this.competencySettingTypeCustomize;
  }

  /**
   * 学校（カスタム）コンピテンシー
   */
  get customCompetencies(): CustomCompetency[] {
    return customCompetencyModule.customCompetencies;
  }

  /**
   * 学校（カスタム）コンピテンシー
   */
  get selectCustomCompetencies(): CustomCompetency[] {
    const defaultSelect = new CustomCompetency();
    defaultSelect.id = 0;
    defaultSelect.name = this.$t('COMPETENCY_SET_OPTION_FREE').toString();
    const result = this.customCompetencies.slice();
    result.unshift(defaultSelect);
    return result;
  }

  // 設問タイプから小学校か判定
  isPrimarySchool() {
    const primaryTypes = [GEnum.QuestionTypes.Primary, GEnum.QuestionTypes.PrimaryL, GEnum.QuestionTypes.GeneralPrimary];
    return primaryTypes.includes(this.evalSettingDetail.questionSettingType);
  }

  // 設問タイプから小学校判定の場合気質診断にチェックが入らないようにする
  iatButtonControl() {
    if (this.isPrimarySchool()) {
      this.evalSettingDetail.iatRequired = false;
      this.evalSettingDetail.iatInactiveFlg = true;
    } else {
      this.evalSettingDetail.iatRequired = true;
      this.evalSettingDetail.iatInactiveFlg = false;
    }
  }

  //設問のタイプ別に有効なコンピテンシーのみ選択可能にする
  handleChangeQuestionSettingType() {
    //設問数に該当するコンピテンシー
    const competenciesIncludeIsValid: Competency[] = masterModule.competenciesByQuestionTypeID(this.evalSettingDetail.questionSettingType);
    masterModule.setCompetenciesIncludeIsValid(competenciesIncludeIsValid);
    examCreateModule.cleanCompetencySelections();
    // 内田洋行タイプの場合 コンピテンシーは固定でセットする
    if (this.isDispCtrlTypeUchida) {
      this.evalSettingDetail.competencySettingType = GEnum.CompetencySettingType.Uchida;
      this.handleChangeCompetencySettingType(GEnum.CompetencySettingType.Uchida);
      this.evalSettingDetail.cleanTrend();
    }
    this.iatButtonControl();
  }

  handleChangeCompetencySettingType(value: GEnum.CompetencySettingType) {
    this.setDefaultQuestionSettingItem();
    // コンピテンシーセットをデフォルトにする
    this.selectCompetencySet = 0;
    switch (value) {
      case GEnum.CompetencySettingType.Full:
        examCreateModule.setCompetencySelections(masterModule.competencies);
        break;
      case GEnum.CompetencySettingType.Recommend:
        examCreateModule.setCompetencySelections(masterModule.competencySettingType.recommendCompetencies.map((competency: SettingType) => masterModule.toCompetency(competency.competencyID)));
        break;
      case GEnum.CompetencySettingType.Mini:
        examCreateModule.setCompetencySelections(masterModule.competencySettingType.miniCompetencies.map((competency: SettingType) => masterModule.toCompetency(competency.competencyID)));
        break;
      case GEnum.CompetencySettingType.Uchida:
        examCreateModule.setCompetencySelections(masterModule.competencySettingType.uchidaCompetencies.map((competency: SettingType) => masterModule.toCompetency(competency.competencyID)));
        break;
      case GEnum.CompetencySettingType.Customize:
        examCreateModule.cleanCompetencySelections();
        break;
    }
  }

  /**
   * 傾向チェックの選択(あり・なし)
   * ライトプラン（内田洋行）の場合、傾向チェックを設定する
   */
  handleChangeTrend(val: boolean) {
    if (this.isDispCtrlTypeUchida) {
      if (val) {
        this.evalSettingDetail.trendIDs = this.trends.map((t: Trend) => t.trendID);
      } else {
        this.evalSettingDetail.trendIDs = [];
      }
    }
  }

  /**
   * 学校コンピテンシー(select box)の選択時、マッチするコンピテンシーを受検にセットする
   */
  handleChangeCustomCompetencySet(val: number) {
    examCreateModule.cleanCompetencySelections();
    if (val !== 0) {
      const cCompe = this.customCompetencies.find((cc: CustomCompetency) => {
        if (cc.id == val) return cc;
      });
      const competencies = masterModule.competencies.filter((competency: Competency) => {
        if (cCompe.competencies.includes(competency.competencyID)) return competency;
      });
      examCreateModule.setCompetencySelections(competencies);
    }
  }

  setDefaultQuestionSettingItem() {
    if (this.isPrimarySchool()) {
      this.evalSettingDetail.iatRequired = false;
    } else {
      this.evalSettingDetail.iatRequired = true;
    }
    this.evalSettingDetail.selfEvalRequired = true;
    this.evalSettingDetail.giftRequired = true;
    this.evalSettingDetail.isProgressNotificationRadio = GEnum.RadioLabel.False;
    this.evalSettingDetail.requiredRespondents = 3;
  }

  filterPrimarySchoolTrends(trendID: number): boolean {
    const PrimarySchoolTrend = [GEnum.TrendCheck.SelfLikingP, GEnum.TrendCheck.ComfortLevelP, GEnum.TrendCheck.ToughnessP, GEnum.TrendCheck.SelfLikingPLower, GEnum.TrendCheck.ComfortLevelPLower, GEnum.TrendCheck.ToughnessPLower];
    return PrimarySchoolTrend.includes(trendID);
  }

  convertToCompetencyTooltip(content: SettingType[]): string {
    return !content ? '' : content.map(d => d.name).join(' | ');
  }

  get trends(): Trend[] {
    if (this.isDispCtrlTypeUchida) {
      if (this.isPrimarySchool()) {
        // 画面制御タイプ「ライトプラン」かつ、設問タイプが「小学校」に該当するものの場合
        return masterModule.trendsDispCtrlTypeLightElementarySchool;
      } else {
        // 画面制御タイプ「ライトプラン」かつ、小学校でない場合
        return masterModule.trendsDispCtrlTypeLight;
      }
    } else {
      return masterModule.trends;
    }
  }

  @Watch('evalSettingDetail.trendRequiredRadio')
  convertTrendRequired(newVal: GEnum.RadioLabel) {
    this.evalSettingDetail.trendRequired = this.convertRadioToBoolean(newVal);
    if (newVal === GEnum.RadioLabel.False) {
      this.evalSettingDetail.trendIDs = [];
    }
  }
}
